// Vanilla-JS port of the source app's <TapDemo>: idle -> tapping -> connected state
// machine driving a data-stage attribute that CSS/markup respond to.
(function () {
  function setup(root) {
    var stageEl = root;
    var tapButton = root.querySelector('[data-tap-demo-tap]');
    var resetButton = root.querySelector('[data-tap-demo-reset]');
    var idlePanel = root.querySelector('[data-tap-demo-idle-panel]');
    var connectedPanel = root.querySelector('[data-tap-demo-connected-panel]');
    var timer = null;

    function setStage(stage) {
      stageEl.setAttribute('data-stage', stage);
      if (tapButton) {
        tapButton.disabled = stage === 'tapping';
        tapButton.textContent = stage === 'tapping' ? 'Connecting…' : 'Tap the card';
      }
      if (idlePanel) idlePanel.hidden = stage === 'connected';
      if (connectedPanel) connectedPanel.hidden = stage !== 'connected';
    }

    if (tapButton) {
      tapButton.addEventListener('click', function () {
        if (stageEl.getAttribute('data-stage') !== 'idle') return;
        setStage('tapping');
        timer = window.setTimeout(function () {
          setStage('connected');
        }, 700);
      });
    }

    if (resetButton) {
      resetButton.addEventListener('click', function () {
        if (timer) clearTimeout(timer);
        setStage('idle');
      });
    }
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    document.querySelectorAll('[data-tap-demo]').forEach(setup);
  });
})();
